import { Navigate, createFileRoute } from '@tanstack/react-router';
import { useUser } from '@/lib/auth/useUser';
import { useActiveOrg } from '@/stores/activeOrgStore';
import { Spinner } from '@/components/atoms/Spinner';
import { DashboardScreen } from '@/features/dashboard/DashboardScreen';
import { AuthenticatedShell } from '@/features/app/AuthenticatedShell';

export const Route = createFileRoute('/dashboard')({ component: DashboardPage });

/**
 * T217 — /dashboard with role-guarded redirect.
 * Only Developer / DeveloperOrgAdmin / PlatformAdmin can see the project
 * dashboard. Funder / FunderOrgAdmin land back at home (they have a
 * different surface in F-003+).
 */
function DashboardPage() {
  const me = useUser();
  const activeOrgId = useActiveOrg((s) => s.activeOrgId);

  if (me.isLoading || !me.data) {
    return <div className="flex min-h-screen items-center justify-center"><Spinner aria-label="Loading" /></div>;
  }

  const active =
    me.data.memberships.find((m) => m.organization.id === activeOrgId) ?? me.data.memberships[0];
  if (!active) return <Navigate to="/" replace />;

  const allowed =
    active.role === 'Developer' ||
    active.role === 'DeveloperOrgAdmin' ||
    active.role === 'PlatformAdmin';

  if (!allowed) return <Navigate to="/" replace />;

  return (
    <AuthenticatedShell activeNavId="projects">
      <DashboardScreen />
    </AuthenticatedShell>
  );
}
